import { DefaultTheme } from "styled-components/native";
import { VDBIcons } from "./VDBIcons";
import { Dimensions } from "react-native";
import Constants from "expo-constants";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";

export const { deviceWidth: screenWidth } = useIsFoldable();
export const screenHeight = Dimensions.get("window").height;

export const SCROLL_STEP = 100;

export const release_name =
  (process.env.APP_SLUG ? process.env.APP_SLUG : Constants?.expoConfig?.slug) +
  "@" +
  (process.env.APP_VERSION
    ? process.env.APP_VERSION
    : Constants?.expoConfig?.version) +
  "@" +
  (process.env.EXPO_PUBLIC_BUILD_DATE
    ? process.env.EXPO_PUBLIC_BUILD_DATE
    : Constants?.expoConfig?.buildDate);

export enum GlobalEnum {
  OUT_ON_MEMO = 0,
  ON_HAND = 1,
  PLEASE_EMAIL = 2,
}

export enum ScreenName {
  PROFILE = "profile",
  TABS = "tabs",
}

export enum BulkRequestHeader {
  SHARE = "share",
  DELETE = "delete",
  MOVE_TO_FAVORITES = "move_to_favorites",
  SHARE_EMAIL = "share_via_email",
  SHARE_NATIVE = "share_via_native",
  SHARE_VIA_LINK = "share_via_link",
}
export enum DeviceType {
  WEB = "web",
  IOS = "ios",
  ANDROID = "android",
}

export enum ProductCategory {
  DIAMOND = "diamond",
  GEMSTONE = "gemstone",
  JEWELRY = "jewelry",
  LAB_GROWN_DIAMOND = "lab_grown_diamond",
  LABGROWN_JEWELRY = "lab_grown_jewelry",
  DEFAULT = "default",
  HOME = "home",
}

export enum ProductPrefixCategory {
  DIAMOND = "natural-diamonds",
  LAB_GROWN_DIAMOND = "lab-grown-diamonds",
  GEMSTONE = "gemstones",
  JEWELRY = "jewelry",
  LAB_GROWN_JEWELRY = "lab-grown-jewelry",
}

export const getProductPrefix = (category: ProductCategory) => {
  switch (category) {
    case ProductCategory.DIAMOND:
      return ProductPrefixCategory.DIAMOND;

    case ProductCategory.LAB_GROWN_DIAMOND:
      return ProductPrefixCategory.LAB_GROWN_DIAMOND;

    case ProductCategory.GEMSTONE:
      return ProductPrefixCategory.GEMSTONE;

    case ProductCategory.JEWELRY:
      return ProductPrefixCategory.JEWELRY;

    default:
      return ProductPrefixCategory.DIAMOND;
  }
};

export enum SectionName {
  JEWELRY = "Jewelry",
  LABGROWN_JEWELRY = "Lab-Grown Jewelry",
  SINGLE_STONES = "Single Stones",
}

export enum ProductTypeCommon {
  LABGROWN_JEWELRY_SUB_TYPE = "labgrown",
}

export enum REQUEST_ACTIONS {
  NEW = "new",
  ACCEPTED = "accepted",
  DECLINE = "decline",
  MODIFIED = "modified",
  WITHDRAW = "withdraw",
  EXPIRED = "expired",
}

export enum NotificationType {
  MESSAGE = "message",
  REQUEST = "request",
  ORDER_CART_APPROVED = "order_cart_approved",
}

export enum ViewType {
  BUYER = "buyer_view",
  SELLER = "seller_view",
}

export enum ProductCategoryShort {
  DIAMOND_SHORT = "diam",
  GEMSTONE_SHORT = "gem",
  JEWELRY_SHORT = "jewelry",
  LABGROWN_SHORT = "lab",
  LABGROWN_JEWELRY_SHORT = "lab",
}

export const STORAGE_KEYS = {
  SELECTED_LANGUAGE: "selectedLanguage",
} as const;

export const getDefaultSearchGroupSection = (theme: DefaultTheme) => [
  {
    data: [
      {
        itemLeftText: "Natural Diamonds",
        key: "diamond",
        leftIcon: VDBIcons.UPD_DIAMONDS,
        leftIconTheme: theme["diam-01"],
        rightIcon: VDBIcons.ARROW_RIGHT,
        rightIconTheme: "diamond",
        itemRightText: "diamond",
        action: "natural_daimonds",
      },
      {
        itemLeftText: "Lab-Grown Diamonds",
        key: "lab_grown_diamond",
        leftIcon: "upd-labGrown",
        leftIconTheme: theme["lab-01"],
        rightIcon: VDBIcons.ARROW_RIGHT,
        rightIconTheme: "lab_grown",
        itemRightText: "lab_grown",
        action: "lab_grown_daimonds",
      },
      {
        itemLeftText: "Colored Gemstones",
        key: "gemstone",
        leftIcon: "upd-gemstones",
        leftIconTheme: theme["gem-01"],
        rightIcon: VDBIcons.ARROW_RIGHT,
        rightIconTheme: "gemstones",
        itemRightText: "gemstones",
        action: "colored_gemstones",
      },
      {
        itemLeftText: "Jewelry",
        key: "jewelry",
        leftIcon: "upd-jewelry",
        leftIconTheme: theme["jewelry-01"],
        rightIcon: VDBIcons.ARROW_RIGHT,
        rightIconTheme: "jewelry",
        itemRightText: "jewelry",
        action: "jewelry",
      },
    ],
  },
];

export const topDetailsData = [
  {
    label: "Cut",
  },
  {
    label: "Pol",
  },
  {
    label: "Sym",
  },
  {
    label: "Fluor",
  },
];

export const middleDetailsData = [
  {
    label: "Meas",
    priceMode: [0, 1, 2],
  },
  {
    label: "Report",
    priceMode: [0, 1, 2],
  },
  {
    label: "H&A",
    priceMode: [0, 1, 2],
  },
  {
    label: "RAP",
    priceMode: [1, 2],
  },
  {
    label: "Item Loc.",
    priceMode: [1, 2],
  },
];

export enum ProductStockType {
  DIAMOND = "Diamond",
  GEMSTONE = "Gemstone",
  JEWELRY = "Jewelry",
  LAB_GROWN_DIAMOND = "LabGrownDiamond",
  DEFAULT = "default",
}
export const JEWELRY_SELECTED_TYPE_PAYLOAD = "jewelry_styles";

export type AuxPayloadCategory = {
  [key: string]: any;
};

export type AuxPayload = {
  [category: string]: AuxPayloadCategory;
};

export type FiltersState = {
  auxPayload: AuxPayload;
  payload: any;
};

export enum StockItemTypeEnum {
  DIAMOND = "Diamond",
  GEMSTONE = "Gemstone",
  JEWELRY = "Jewelry",
  LAB_GROWN_DIAMOND = "LabGrownDiamond",
  LABGROWN_JEWELRY = "LabGrownJewelry",
  DEFAULT = "default",
}

export enum BulkRequestEnum {
  FromPdp = "FromPdp",
  FromResultScreen = "FromResultScreen",
  FromFavorites = "FromFavorites",
  FromBulkCart = "FromBulkCart",
}

export enum AddJewelryOptions {
  ENGAGEMENT_RING = "engagement_ring",
  PENDANT = "Pendant",
  EARRINGS = "earrings",
}

export enum MediaType {
  IMAGE = "image",
  VIDEO = "video",
  MODEL_3D = "3D",
  PDF = "pdf",
}
